import type { ISubject, IObserver, ObserverActionMap } from './types';

/* global Set */
// Use the basic APIs of ES6 Set. If your site supports browsers not
// having Set natively, you should use a polyfill

/* Subject to observe */
export class Subject implements ISubject {
  observers: Set<IObserver>;

  constructor() {
    this.observers = new Set();
  }

  /**
   * Subscribe an observer to the subject
   * @param {Object} observer - The observer subscribing to the subject
   * @returns {void}
   */
  subscribe(observer: IObserver): void {
    if (!(observer instanceof Object)) {
      throw new Error('Invalid observer');
    }
    this.observers.add(observer);
  }

  /**
   * Unsubscribe an observer from the subject
   * @param {Object} observer - The observer to unsubscribe
   * @returns {void}
   */
  unsubscribe(observer: IObserver): void {
    this.observers.delete(observer);
  }

  /**
   * Notify the observers for a certain action
   * @param {string} action -
   *  Name of the action, it will map to the handler method name on the observer
   * @param {...*} args - Additional arguments
   * @returns {void}
   */
  notify(action: string, ...args: unknown[]): void {
    this.observers.forEach((observer: IObserver) => {
      const handler = (observer as ObserverActionMap)[action];

      if (typeof handler === 'function') {
        handler.call(observer, this, ...args);
      }
    });
  }
}
